// extracted by mini-css-extract-plugin
module.exports = {"product-price":"ProductPrice_product-price__pbE2k","line-through":"ProductPrice_line-through__bC24b"};